// @ts-check

import { CONFIG } from "./injector";

/**
 * @typedef {import('~blocks/types').ComponentBlock} ComponentBlock
 * @typedef {import('./injector').BlockInjectorData} BlockInjectorData
 * @typedef {import('./injector').ComponentBlockWithInjectorData} ComponentBlockWithInjectorData
 * @typedef {import('./injector').LayoutContext} LayoutContext
 */

/**
 * Calculate the total distance and time it takes to read the article
 * @param {Array<ComponentBlock | ComponentBlockWithInjectorData>} componentBlocks
 * @param {LayoutContext} context
 * @returns {Array<BlockInjectorData['weights']>}
 */
export function calculateContentWeights(
  componentBlocks = [],
  { contentWidth = 335, charsPerLine = 75 } = {},
) {
  // let totalDistance = 0;
  // let totalTime = 0;
  // console.log("[calculateContentWeights]", { contentWidth, charsPerLine });
  let weights = componentBlocks.map((componentBlock) => {
    const baseValue = componentBlock?.data?.weights?.baseDepth || 1;
    /** @type {BlockInjectorData['weights']} */
    const blockWeight = {
      baseDepth: baseValue,
      distance: baseValue,
      time: baseValue,
      depth: baseValue,
      ...componentBlock?.data?.weights,
    };

    // Calculate depth for paragraphs by:
    // 1. Estimating the number of lines it takes up
    // 2. Dividing by the number of lines in a "full" paragraph
    // 3. Averaging this with the estimated reading time
    if (componentBlock?.block?.type === "paragraph") {
      const chars = componentBlock?.data?.stats?.chars || 0;
      const readTime = componentBlock?.data?.stats?.time || 0;
      const lines = Math.ceil(chars / charsPerLine);

      // Normalizing paragraphs into blocks. If we assume a "normal" paragraph
      // is 5 lines, a 2 line paragraph counts as 0.2 blocks.
      blockWeight.distance = lines / CONFIG.standardParagraphLines;
      blockWeight.time = readTime / CONFIG.standardParagraphTime;

      // Made up concept that's a "smarter" distance that can fall back to
      // readtime when we don't know the number of lines exactly.
      blockWeight.depth = (blockWeight.distance + blockWeight.time) / 2;
    } else if (componentBlock?.data?.stats?.time) {
      blockWeight.time =
        (blockWeight.time || 0) + componentBlock.data.stats.time / CONFIG.standardParagraphTime;
      blockWeight.depth = blockWeight.time;
    }

    return blockWeight;
  });

  return weights;
}
